// extracted by mini-css-extract-plugin
module.exports = {"nav":"FacetNavbar_nav__bDea3","facetSelected":"FacetNavbar_facetSelected___i2rv"};